/**
 * Money helpers for the frontend, mirroring backend/src/common/money.ts so both
 * codebases round currency the same way. All amounts are 2-decimal (paise), so
 * comparisons round to 2 decimals first to avoid binary floating-point drift
 * (e.g. 0.1 + 0.2 !== 0.3).
 *
 * Note: this is for money MATH / comparisons. Whole-rupee DISPLAY formatting
 * (e.g. a "₹150 BMF Coins" label) deliberately uses Math.round elsewhere — that
 * is an intentional presentation choice, not a precision bug.
 */

/** Round a value to 2 decimals (currency), guarding against FP representation error. */
export const round2 = (value) =>
  Math.round((Number(value) + Number.EPSILON) * 100) / 100;

/** Currency display shared by Admin Users and the user report export. */
export const formatUserCurrency = (amount) => new Intl.NumberFormat('en-IN', {
  style: 'currency',
  currency: 'INR',
  minimumFractionDigits: 0,
}).format(amount);
